module.exports = __webpack_public_path__ + "img/login.a7b2d045.svg";